import React, { useState } from "react";

import MenuItem from "./menuItem";
import ChevronDownIcon from "@heroicons/react/24/outline/ChevronDownIcon";

interface MenuItemData {
  text: string;
  icon: React.ElementType;
  route: string;
}

interface Props {
  label: string;
  items: MenuItemData[];
  onItemClick: (route: string) => void;
  currentPath: string;
}

const CollapsibleMenuItem: React.FC<Props> = ({ label, items, onItemClick, currentPath }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div
        className="flex items-center justify-between px-4 py-2 cursor-pointer hover:bg-content3 rounded-xl"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="font-semibold">{label}</span>
        <ChevronDownIcon
            className={`w-6 transition-all duration-300 ${
              isOpen ? "rotate-180" : "rotate-0"
            } ${isOpen ? "text-primary" : "text-textsecondary"}`}
          />
      </div>

      {isOpen && (
        <div className="pl-4">
          {items.map((item) => (
            <MenuItem
              key={item.route}
              text={item.text}
              icon={item.icon}
              onClick={() => onItemClick(item.route)}
              isSelected={currentPath.startsWith(item.route)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CollapsibleMenuItem;